<script setup lang="ts">
defineProps<{
  data: HighlightedComponentType;
}>();
</script>

<template>
  <section class="flex w-full flex-col items-center gap-4 bg-green-30 pb-24 pt-8">
    <h2 class="-mb-2 mt-[2.4rem] text-base uppercase text-green-50">
      Aktuelt
    </h2>
    <h3 class="font-headline text-3xl text-green-50" v-text="data.title" />
    <div class="relative">
      <UiStripesArticles :articles="data.articles" :range="[0, 2]" />

      <UiRotateWithScroll class="stamp z-10 hidden">
        <UiGraphicsHighlight aria-hidden="true" />
      </UiRotateWithScroll>
    </div>
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.stamp {
  @media screen and (min-width: theme("screens.sm")) {
    display: block;
    bottom: -2.5rem;
    right: 8rem;
  }

  @media screen and (min-width: theme("screens.tablet")) {
    bottom: -3rem;
    right: -2rem;
  }
}
</style>
